import { render } from "./ViewFlashMessageDetail.vue?vue&type=template&id=9f557a86"
import script from "./ViewFlashMessageDetail.vue?vue&type=script&lang=js"
export * from "./ViewFlashMessageDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__